export const apiServer = process.env.VUE_APP_API_URI;
export const staticServer = process.env.VUE_APP_STATIC_URI;
